export default "__VITE_ASSET__DIdaLHwo__"